//상단 고정 헤더, “통합 동아리 플랫폼” 제목 표시, 로그인/로그아웃 버튼

import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { supabase } from "../../lib/supabaseClient";
import "./Header.css";
import homeIcon from "../../assets/images/home.png";
import bellIcon from "../../assets/images/bell.png";
import calendarIcon from "../../assets/images/calendar.png";
import userIcon from "../../assets/images/user.png";


function Header() {
  const [session, setSession] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    // 초기 렌더링 시 현재 세션 상태 확인 (페이지 새로고침 후 로그인 유지에 필요)
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    // 로그인·로그아웃 시 실시간으로 세션 상태를 감지해 헤더 UI 자동 갱신
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    // cleanup: 컴포넌트 언마운트 시 구독 해제
    return () => subscription.unsubscribe();
  }, []);


  // session이 바뀔 때마다 안 읽은 알림 수를 조회해 뱃지에 표시
  // count 옵션으로 직접 집계해 전체 row를 가져오지 않고 숫자만 받음
  useEffect(()=>{
    const fetchUnreadCount= async() =>{
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        return;
      }

      const { data: userData, error:userError } = await supabase
      .from("users")
      .select("*")
      .eq("email", session.user.email)
      .single();

      if(userError){
        console.log("알림에서 유저이메일을 불러오지 못함");
        return;
      }

      const {count, error} = await supabase
      .from('notifications')
      .select('*', { count: 'exact', head: true })
      .eq('user_id', userData.id)
      .eq('is_read', false);

      if (!error && count !== null) {
        setUnreadCount(count);
      }
    };
    fetchUnreadCount();

    const headerNoticeSubscription = supabase
      .channel('header-unread-count')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'notifications' },
        (payload) => {
          console.log('헤더에서 알림 테이블 변화 감지!', payload);
          fetchUnreadCount(); 
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(headerNoticeSubscription);
    };
  },[session]);

  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    alert("로그아웃 됐습니다 !");
    navigate("/");
  };

  return (
    <header className="header-container">
      <div className="header-logo">
        <Link to="/" className="logo-text">CampusNow</Link>
      </div>

      <nav className="header-nav">
        {session ? (
          <button className="nav-logout" onClick={handleLogout}>로그아웃</button>
        ) : (
          <Link to="/login" className="nav-login">로그인</Link>
        )}
        
        <NavLink to="/" className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}>
          <img src={homeIcon} alt="홈" className="nav-icon" /> 
          <span className="nav-text">홈</span>
        </NavLink>

        <NavLink
          to="/notifications"
          className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          onClick={(e) => {
            if (!session) {
              e.preventDefault();
              alert("로그인을 해주세요!");
            }
          }}
        >
          <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img src={bellIcon} alt="알림" className="nav-icon" />
            {unreadCount > 0 && (
            <span style={{
              position: 'absolute',
              top: '-5px',
              right: '-5px',
              backgroundColor: 'red',
              color: 'white',
              borderRadius: '50%',
              padding: '2px 6px',
              fontSize: '8px',
              fontWeight: 'bold'
            }}>
              {unreadCount}
            </span>
          )}
          </div>
          <span className="nav-text">알림</span>
        </NavLink>

        <NavLink
          to="/club/1/schedule"
          className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          onClick={(e) => {
            if (!session) {
              e.preventDefault();
              alert("로그인을 해주세요!");
            }
          }}
        >
          <img src={calendarIcon} alt="일정" className="nav-icon" />
          <span className="nav-text">일정</span>
        </NavLink>

        <NavLink
          to="/profile"
          className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          onClick={(e) => {
            if (!session) {
              e.preventDefault();
              alert("로그인을 해주세요!");
            }
          }}
        >
          <img src={userIcon} alt="내 프로필" className="nav-icon" />
          <span className="nav-text">내 프로필</span>
        </NavLink>
      </nav>
    </header>
  );
}

export default Header;
